export default __webpack_public_path__ + "static/media/gitGithub_blog.7da95f38.jfif";